module.exports = __webpack_public_path__ + "static/media/StrengthF.4220dda9.png";